export default __webpack_public_path__ + "static/media/meterreading-7.524baea1.png";